import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatSalaryPeriod(period: string): string {
  const normalized = period.trim().toLowerCase();
  return (
    {
      annual: "year",
      annually: "year",
      yearly: "year",
      "per year": "year",
      "per annum": "year",
      hourly: "hour",
      "per hour": "hour",
      monthly: "month",
      "per month": "month",
      weekly: "week",
      "per week": "week",
    }[normalized] ?? period
  );
}

/**
 * Format job location for display
 */
export function formatLocation(job: {
  isRemote?: boolean | null;
  country?: string | null;
  city?: string | null;
  state?: string | null;
}): string {
  if (job.isRemote) {
    return job.country ?? "Remote";
  }

  const parts: string[] = [];
  if (job.city) parts.push(job.city);
  if (job.state) parts.push(job.state);

  const location = parts.join(", ");
  if (location && job.country) {
    return `${location} (${job.country})`;
  }
  if (location) {
    return location;
  }
  if (job.country) {
    return job.country;
  }
  return "Location not specified";
}

/**
 * Format posted date for display
 * Returns { label: string, isNew: boolean, colorClass: string }
 */
export function formatPostedDate(date: Date | string | null | undefined): {
  label: string;
  isNew: boolean;
  colorClass: string;
} {
  if (!date) {
    return { label: "", isNew: false, colorClass: "text-blue-600" };
  }

  const posted = new Date(date);
  const now = new Date();
  const diffMs = now.getTime() - posted.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays <= 3) {
    return { label: "NEW", isNew: true, colorClass: "text-green-600" };
  }
  if (diffDays <= 6) {
    return {
      label: `${diffDays} days ago`,
      isNew: false,
      colorClass: "text-green-600",
    };
  }
  if (diffDays <= 13) {
    return { label: "1 week ago", isNew: false, colorClass: "text-blue-600" };
  }
  if (diffDays <= 29) {
    return { label: "2+ weeks ago", isNew: false, colorClass: "text-blue-600" };
  }
  return { label: "30+ days", isNew: false, colorClass: "text-blue-600" };
}
